import { ActivityHistory } from '../../typings'
import { FetchActivityHistory } from './typings'

export const fetchActivityHistoryActionCreator = (
  payload: ActivityHistory[],
): FetchActivityHistory => ({
  type: 'activityHistory/search',
  payload,
})
